<template>
  <a v-click-outside="closeNavDropDown" class="nav_hamburger" @click="toggleMenu()">
    <menu-bars />
  </a>
</template>
<script>
import MenuBars from '../icons/menu-bars';
import { component } from '../../../mixins/component';
import { EventBus, TOGGLE_TOP_MENU_LOGO, TOGGLE_TOP_MENU, CLICK_TOP_MENU_HAMBURGER } from '../../../event-bus';
import ClickOutside from 'vue-click-outside';

export default {
  components: { MenuBars },
  directives: {
    ClickOutside,
  },
  mixins: [component],
  data() {
    return {
      openNavDropdownMenu: false,
    };
  },
  created() {
    EventBus.$on(TOGGLE_TOP_MENU_LOGO, (isShow, status) => {
      if (isShow) {
        this.openNavDropdownMenu = false;
        EventBus.$emit(TOGGLE_TOP_MENU, this.openNavDropdownMenu);
      }
    });
    EventBus.$on(CLICK_TOP_MENU_HAMBURGER, () => {
      this.openNavDropdownMenu = true;
    });
  },
  beforeDestroy() {
    EventBus.$off(TOGGLE_TOP_MENU_LOGO);
    EventBus.$off(CLICK_TOP_MENU_HAMBURGER);
  },
  methods: {
    toggleMenu() {
      this.openNavDropdownMenu = !this.openNavDropdownMenu;
      EventBus.$emit(TOGGLE_TOP_MENU, this.openNavDropdownMenu);
      const showLogoDropdownMenu = false;
      EventBus.$emit(TOGGLE_TOP_MENU_LOGO, showLogoDropdownMenu, 2);
    },
    closeNavDropDown() {
      // if (!this.isMobile()) {
      this.openNavDropdownMenu = false;
      EventBus.$emit(TOGGLE_TOP_MENU, this.openNavDropdownMenu);
      // }
    },
  },
};
</script>
